import * as Events from "./Events"

export default (state, action) => {
    switch (action.type) {
        case Events.ORGANIZATION_LOADED:
            return {
                ...state,
                currentOrganization: { ...action.payload }
            }
        case Events.STRIPE_LOADED:
            return {
                ...state,
                // payload is not spread to avoid
                // stripe reference change
                stripe: action.payload
            }
        case Events.CLIENT_SECRET_LOADED:
            return {
                ...state,
                clientSecret: action.payload
            }
        case Events.NUM_SEATS_CHANGED:
            return {
                ...state,
                numSeats: action.payload
            }
        case Events.PRICE_SELECTED:
            return {
                ...state,
                selectedPlan: action.payload
            }
        case Events.INTERVAL_CHANGED:
            return {
                ...state,
                interval: state.interval === "monthly" ? "annually" : "monthly"
            }
        case Events.CURRENT_SUBSCRIPTION_LOADED:
            return {
                ...state,
                currentSubscription: action.payload
            }
        case Events.CURRENT_SUBSCRIPTION_STRIPE_DATA_LOADED:
            return {
                ...state,
                currentSubscriptionStripeData: { ...action.payload }
            }
        case Events.PAYMENT_METHODS_LOADED:
            return {
                ...state,
                paymentMethods: action.payload.map(paymentMethod => ({
                    ...paymentMethod,
                    isExpired: isCardExpired(paymentMethod)
                }))
            }
        case Events.PAYMENT_METHOD_SELECTED:
            return {
                ...state,
                selectedPaymentMethodId: action.payload
            }
        case Events.TOGGLE_DOWNGRADE_DIALOG:
            return {
                ...state,
                showDowngradeDialog: !state.showDowngradeDialog
            }
        case Events.TOGGLE_SEAT_OVERFLOW_DIALOG:
            return {
                ...state,
                showSeatOverflowDialog: !state.showSeatOverflowDialog
            }
        case Events.TOGGLE_ROLE_OVERFLOW_DIALOG:
            return {
                ...state,
                showRoleOverflowDialog: !state.showRoleOverflowDialog
            }
        case Events.SELECTED_SUBSCRIPTION_PARAMETERS_LOADED:
            return {
                ...state,
                selectedSubscriptionParameters: {
                    ...action.payload
                }
            }
        case Events.TOGGLE_PROJECT_OVERFLOW_DIALOG:
            return {
                ...state,
                showProjectOverflowDialog: !state.showProjectOverflowDialog
            }
        case Events.NUM_ACTIVE_PROJECTS_LOADED:
            return {
                ...state,
                numberOfActiveProjects: action.payload
            }
        case Events.TOGGLE_ADD_NEW_CARD_DIALOG:
            return {
                ...state,
                showAddNewCardDialog: !state.showAddNewCardDialog
            }
        case Events.NEW_CARD_ADDED:
            return {
                ...state,
                paymentMethods: [
                    ...state.paymentMethods,
                    action.payload
                ]
            }
        case Events.NEW_PRICE_DATA_LOADED:
            return {
                ...state,
                loadingNewPriceData: false,
                newPriceData: action.payload
            }
        case Events.NEW_PRICE_DATA_LOADING:
            return {
                ...state,
                loadingNewPriceData: true
            }
        case Events.PRICE_CHANGE_SUCCESSFUL:
            return {
                ...state,
                priceChangeSuccessful: true
            }
        case Events.ORGANIZATION_STRIPE_DATA_LOADED:
            return {
                ...state,
                currentOrganizationStripeData: {
                    ...action.payload
                }
            }
        case Events.SET_BILLING_INFORMATION:
            return {
                ...state,
                billingInformation: {
                    ...action.payload
                }
            }
        case Events.SET_TAX_INFO:
            return {
                ...state,
                taxInfo: {
                    ...action.payload
                }
            }
        case Events.PAYMENT_INFORMATION_VALID_STATE_CHANGED:
            return {
                ...state,
                paymentInformationValid: action.payload
            }
        case Events.SUBSCRIPTIONS_LOADED:
            return {
                ...state,
                subscriptions: [...action.payload]
            }
        default:
            return state
    }
}

function isCardExpired(paymentMethod) {
    const today = new Date();
    const expDate = new Date(paymentMethod.card.exp_year, paymentMethod.card.exp_month - 1);
    return expDate < today;
}